export default "__VITE_ASSET__70fa930f__"